import './ResponsiveImage.scss';
import * as React from 'react';
import { classList } from 'src/utils/classList';
import { IMG_SIZES } from 'src/constants/imgSizes';

type Props = {
    readonly src: string;
    readonly alt?: string;
    readonly className?: string;
};

export class ResponsiveImage extends React.Component<Props> {
    public render(): JSX.Element {
        const { src, className } = this.props;
        try {
            const url = new URL(src);

            return (
                <div className={classList(className, 'lvo-responsive-image')}>
                    {url.host.includes('img.engadin')
                        ? this.renderEstmImage()
                        : (url.host.includes('xiag') || url.host.includes('levo'))
                            ? this.renderLevoImage()
                            : this.renderDefaultImage()}
                </div>
            );
        } catch (e) {
            console.error(e);
            return (
                <div className={classList(className, 'lvo-responsive-image')}>
                    {this.renderDefaultImage()}
                </div>
            );
        }
    }

    private renderEstmImage(): JSX.Element {
        const { src, alt = '' } = this.props;

        return (
            <img src={src}
                 alt={alt}
                 srcSet={getEstmSrcSet(src)}
                 sizes={IMG_SIZES}/>
        );
    }

    private renderLevoImage(): JSX.Element {
        const { src, alt = '' } = this.props;

        return (
            <img src={src}
                 alt={alt}
                 srcSet={getLevoSrcSet(src)}
                 sizes={IMG_SIZES}/>
        );
    }

    private renderDefaultImage(): JSX.Element {
        const { src, alt = '' } = this.props;

        return (
            <img src={src}
                 alt={alt}/>
        );
    }
}

const ESTM_AVAILABLE_SIZES = [
    '320',
    '410',
    '500',
    '570',
    '640',
    '768',
    '830',
    '900',
    '1024',
    '1200',
    '1366',
    '1530',
    '1600',
    '1920',
    '2048',
    '2200',
    '2500',
    '2700',
    '2900',
    '3072',
];
const LEVO_AVAILABLE_SIZES = [
    '300',
    '500',
    '1000',
    '1500',
    '2000',
    '2500',
    '3000',
];

function getEstmSrcSet(src: string): string {
    if (src.match(/\/[^\/]+\.(png|jpg|jpeg)$/i)) {
        return ESTM_AVAILABLE_SIZES
            .map((width) => src.replace(/\/[^\/]+\.(png|jpg|jpeg)$/i, `/${width}x.$1 ${width}w`)).join(',');
    }

    return ESTM_AVAILABLE_SIZES
        .map((width) => src.replace(/\/[^\/]+$/i, `/${width}x.jpg ${width}w`)).join(',');
}

function getLevoSrcSet(src: string): string {
    return LEVO_AVAILABLE_SIZES
        .map((width) => `${src.replace('/500/-/', `/${width}/-/`)} ${width}w`)
        .join(',');
}
